module.exports = __webpack_public_path__ + "img/programme3.3a11d3cc.png";